import React from "react"
import {withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import BaseComponent from "../../../base-component";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {handleApiResponse} from "../../../../crud-actions";
import {displayErrors, parsePropertiesErrors} from "../../../../form-helpers";
import {Link} from "react-router-dom";
import SuccessModal from "../../success-modal";

class PersonalFormSubmitModal extends BaseComponent {
    render() {
        const { isOpen, isSubmitting, toggle, submit } = this.props;

        return (
            <Modal isOpen={isOpen || isSubmitting} toggle={toggle} className={this.props.className} size='lg'>
                <ModalHeader toggle={toggle}><FormattedMessage id='app.personal_forms.submit_modal.title'/></ModalHeader>
                <ModalBody>
                    <p><FormattedMessage id='app.personal_forms.submit_modal.confirmation'/></p>
                    <p><FormattedMessage id='app.personal_forms.changes'/></p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => { submit(); toggle(); }} disabled={isSubmitting}><FormattedMessage id='app.personal_forms.submit_modal.submit'/>{this.spinner(isSubmitting)}</Button>
                    <Button color="secondary" onClick={toggle}><FormattedMessage id='app.personal_forms.submit_modal.close'/></Button>
                </ModalFooter>
            </Modal>
        )
    };
}

class Page6 extends BaseComponent {

    constructor(params) {
        super(params);
        this.state = {
            successModal: false,
            submitModal: false
        }
    }

    toggleSubmitModal = () => {
        this.setState({ submitModal: !this.state.submitModal });
        document.activeElement.blur();
    };

    sendForm = (values, form) => {
        let promise = this.props.assignmentAction('api/v1', this.props.assignment.id, { execute: 'submit_form', data: values.data });
        handleApiResponse('ASSIGNMENT', 'ACTION', promise,
            (result) => {
                this.setState({...this.state, successModal: true});
            },
            (result) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.personal_forms.message.submit.fail'}));
                let errors = result.payload.response.errors;
                errors = parsePropertiesErrors(errors, 'data');
                form.setErrors(errors);
            },
            (error) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
                console.log(error);
            }).then(() => {
            form.setSubmitting(false);
        });
    };

    render() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, submitForm, isSubmitting, setFieldValue, contentUnit, assignment, isComplete } = this.props;
        const disableSubmit = !(values.data.exclusivity && values.data.correctness);

        return (
            <form onSubmit={handleSubmit}>
                <div>
                    <div className='clearfix'>
                        <p><strong><FormattedMessage id='app.personal_forms.attribute.last_info'/></strong></p>
                        <div className='form-group'>
                            <div className="custom-control custom-switch pb-4">
                                <input disabled={isComplete} type="checkbox" className="custom-control-input" id='data.exclusivity' name='data.exclusivity' value={values.data.exclusivity} checked={values.data.exclusivity} onChange={handleChange}/><label className="custom-control-label" htmlFor="data.exclusivity"><span className='required-field'><FormattedMessage id='app.personal_forms.attribute.exclusivity'/></span></label>
                            </div>
                            { displayErrors(errors, 'data.exclusivity') }
                        </div>

                        <div className='form-group'>
                            <div className="custom-control custom-switch">
                                <input disabled={isComplete} type="checkbox" className="custom-control-input" id='data.correctness' name='data.correctness' value={values.data.correctness} checked={values.data.correctness} onChange={handleChange}/><label className="custom-control-label" htmlFor="data.correctness"><span className='required-field'><FormattedMessage id='app.personal_forms.attribute.correctness'/></span></label>
                            </div>
                            { displayErrors(errors, 'data.correctness') }
                        </div>

                        <hr/>
                        <button type='button' className='btn btn-secondary' onClick={this.props.previous}>{intl.formatMessage({id: 'app.personal_forms.buttons.previous_step'})}</button>
                        { !isComplete && <button type='button' disabled={disableSubmit || isSubmitting} className='btn btn-primary float-right' onBlur={handleBlur} onClick={this.toggleSubmitModal}>{intl.formatMessage({id: 'app.personal_forms.buttons.submit'})}{this.spinner(isSubmitting)}</button> }
                        { isComplete && <button type='button' className='btn btn-primary float-right' onBlur={handleBlur} onClick={this.props.next}>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}</button> }
                    </div>
                </div>
                <PersonalFormSubmitModal isOpen={this.state.submitModal} toggle={this.toggleSubmitModal} submit={submitForm} isSubmitting={isSubmitting}/>
                <SuccessModal isOpen={this.state.successModal}>
                    <ModalHeader>{contentUnit.title}</ModalHeader>
                    <ModalBody>
                        <FormattedMessage id='app.personal_forms.message.submit.success'/>
                    </ModalBody>
                    <ModalFooter>
                        <Link to='/dashboard' className={'btn btn-green'}><FormattedMessage id='app.actions.ok'/></Link>
                    </ModalFooter>
                </SuccessModal>
            </form>
        );
    }

}

export default injectIntl(withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        let model = { data: { ...props.resource.data, page: 7 } };
        return model;
    },
    handleSubmit: (values, form) => {
        form.props.submit(values, form);
        },
    displayName: 'BasicForm',
})(Page6));
